class MainSearch extends SearchForm {
  constructor() {
    super();
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.input.addEventListener('focus', this.onInputFocus.bind(this));
    this.input.addEventListener('keydown', this.onInputKeydown.bind(this));
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      this.scrollIntoView({ behavior: 'smooth' });
    }
  }

  onInputKeydown(event) {
    if (event.key !== 'Enter' || !this.input.value.trim()) return;

    const predictiveSearch = this.closest('predictive-search');
    const selectedResult = predictiveSearch?.querySelector(
      '[aria-selected="true"] a, button[aria-selected="true"]'
    );
    if (selectedResult) return;

    event.preventDefault();
    this.input.form?.requestSubmit();
  }
}

customElements.define('main-search', MainSearch);
